import React from 'react';
import styled from "styled-components";
import ShelveItem from "./ShelveItem";
import CameraShelfMarkerEditor from "../camera/CameraShelfMarkerEditor";
import CameraPoseDetection from "../camera/CameraPoseDetection";
import {CAMERA_TYPE_ENUM} from "../../maps/data_types";

const WrapperStyled = styled.div`
  h3 {
    font-size: 11px;
    margin: 0;
    text-decoration: underline;
  }
`;

const ShelfWrapperStyled = styled.div`
  margin: 0;
`;

const FieldItem = ({field, productsDetection, shelvesDetection, fieldSize, indications, poseDetection, currentWeight, openWeightHandle, forceUpdateFields,eventStats}) => {
    const shelves = field?.shelves;
    const shelvesExits = !!shelves?.length;

    const cameras = field.cameras || [];
    const topCamera = cameras.find(cam => cam.cameraType === 'TOP');
    const camerasWithoutTopAll = cameras.filter(cam => cam.cameraType !== CAMERA_TYPE_ENUM.TOP);
    const camerasWithoutTop = camerasWithoutTopAll.filter(cam => cam.aiProfile);
    const topCameraBorder = topCamera?.cameraBorder;

    const topCameraExists = topCamera && Object.keys(topCamera).length > 0;

    const filteredPoseData = poseDetection.find(pp => pp.cameraId === topCamera?._id);

    return (
        <WrapperStyled>
            <h3>{field?.name}</h3>
            {camerasWithoutTop.map((cam, idx) => {
                return (
                    <CameraShelfMarkerEditor
                        shelves={shelves}
                        camera={cam}
                        key={cam._id + field?.name + idx}
                        disableControls={true}
                        isPreview={true}
                        productsDetection={productsDetection}
                    />
                );
            })}
            {topCameraExists && (
                <CameraPoseDetection
                    poseDetection={filteredPoseData}
                    camera={topCamera}
                    field={field}
                    key={topCamera._id + field?.name}
                    disableControls={true}
                    isPreview={true}
                    topCameraBorder={topCameraBorder}
                />
            )}
            {shelvesExits && shelves.map((shelf, idx) => {

                const productsItems = productsDetection.filter(pd => {
                    return pd.sensorId === shelf.sensorId
                });

                const shelfsItem = shelvesDetection.find(sd => {
                    return sd.sensorId === shelf.sensorId;
                });

                const shelfIndications = indications[shelf.sensorId];

                const camerasForThisShelf = [];
                shelf?.boundingBoxes?.forEach(box => {
                    const camera = camerasWithoutTop.find(cam => cam._id === box.cameraId);
                    if (camera) {
                        camerasForThisShelf.push(camera);
                    }
                });

                return (
                    <ShelfWrapperStyled key={shelf._id + idx}>
                        {camerasForThisShelf.map((cam, idx) => {

                            const productsItem = productsItems.find(pd => {
                                return pd.cameraId === cam.cameraId;
                            });

                            const weight = currentWeight?.[shelf._id];

                            return (
                                <ShelveItem
                                    forceUpdateFields={forceUpdateFields}
                                    weight={weight}
                                    key={idx + cam._id}
                                    rotate={cam?.rotate}
                                    cameraId={cam?._id}
                                    fieldSize={fieldSize}
                                    shelf={shelf}
                                    field={field}
                                    products={productsItem?.products}
                                    shelfShapes={shelfsItem?.results}
                                    indications={shelfIndications?.items}
                                    showProductImages={true}
                                    openWeightHandle={openWeightHandle}
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr"
                                    }}
                                />
                                
                                
                            );
                        })}
                    </ShelfWrapperStyled>
                );
            })}
        </WrapperStyled>
    );
};

export default FieldItem;